export default __webpack_public_path__ + "static/media/outer-top-corners-rounded-3.156902dd.webp";